var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    height: 512,
    viewBox: "0 0 48 48",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41 8.6h-9.4c-.4 0-.8-.4-.8-.8s.4-.8.8-.8h9.4c.4 0 .8.4.8.8s-.4.8-.8.8z",
    fill: "#ccd0d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m44.4 11.7h-12.7c-.4 0-.8-.4-.8-.8s.4-.8.8-.8h12.7c.4 0 .8.4.8.8s-.4.8-.8.8z",
    fill: "#ccd0d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.4 11.2c-.1-3.4-2.2-4.8-4.9-4.8s-4.8 1.3-4.9 4.8c0 2.5 9.8 2.5 9.8 0z",
    fill: "#ff8080"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 2.1,
    fill: "#ff8080",
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41 26.1h-9.4c-.4 0-.8-.4-.8-.8s.4-.8.8-.8h9.4c.4 0 .8.4.8.8s-.4.8-.8.8z",
    fill: "#ccd0d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m44.4 29.2h-12.7c-.4 0-.8-.4-.8-.8s.4-.8.8-.8h12.7c.4 0 .8.4.8.8s-.4.8-.8.8z",
    fill: "#ccd0d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.4 28.6c-.1-3.4-2.2-4.8-4.9-4.8s-4.8 1.3-4.9 4.8c0 2.6 9.8 2.6 9.8 0z",
    fill: "#72d6c3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 19.5,
    fill: "#72d6c3",
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m41 43.5h-9.4c-.4 0-.8-.4-.8-.8s.4-.8.8-.8h9.4c.4 0 .8.4.8.8 0 .5-.4.8-.8.8z",
    fill: "#ccd0d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m44.4 46.6h-12.7c-.4 0-.8-.4-.8-.8s.4-.8.8-.8h12.7c.4 0 .8.4.8.8 0 .5-.4.8-.8.8z",
    fill: "#ccd0d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m26.4 46.1c-.1-3.4-2.2-4.8-4.9-4.8s-4.8 1.3-4.9 4.8c0 2.5 9.8 2.5 9.8 0z",
    fill: "#ffd576"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 21.5,
    cy: 37,
    fill: "#ffd576",
    r: 2.1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.6 11.4c-2.6 0-4.8-2.1-4.8-4.8 0-2.6 2.2-4.7 4.8-4.7.4 0 .8.4.8.8s-.4.8-.8.8c-1.8 0-3.2 1.4-3.2 3.2s1.4 3.2 3.2 3.2 3.2-1.4 3.2-3.2c0-.4.4-.8.8-.8s.8.4.8.8c-.1 2.6-2.2 4.7-4.8 4.7z",
    fill: "#ccd0d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.6 8.1c-.2 0-.4-.1-.6-.3l-1.4-1.4c-.4-.4-.4-.8 0-1.2.3-.3.8-.3 1.1 0l.9.9 4.3-4.3c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-4.9 4.9c-.1.2-.3.3-.5.3z",
    fill: "#324d5b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.6 28.9c-2.6 0-4.8-2.1-4.8-4.8 0-2.6 2.1-4.8 4.8-4.8.4 0 .8.4.8.8s-.4.8-.8.8c-1.8 0-3.2 1.4-3.2 3.2s1.4 3.2 3.2 3.2 3.2-1.4 3.2-3.2c0-.4.4-.8.8-.8s.8.4.8.8c-.1 2.6-2.2 4.8-4.8 4.8z",
    fill: "#ccd0d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.6 25.5c-.2 0-.4-.1-.6-.2l-1.5-1.5c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l.9.9 4.3-4.3c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-4.8 4.8c-.1.2-.3.3-.5.3z",
    fill: "#324d5b"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.6 46.3c-2.6 0-4.8-2.1-4.8-4.8 0-2.6 2.1-4.8 4.8-4.8.4 0 .8.4.8.8s-.4.8-.8.8c-1.8 0-3.2 1.4-3.2 3.2s1.4 3.2 3.2 3.2 3.2-1.4 3.2-3.2c0-.4.4-.8.8-.8s.8.4.8.8c-.1 2.7-2.2 4.8-4.8 4.8z",
    fill: "#ccd0d2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m7.6 43c-.2 0-.4-.1-.6-.2l-1.5-1.5c-.3-.3-.3-.8 0-1.1s.8-.3 1.1 0l.9.9 4.3-4.3c.3-.3.8-.3 1.1 0s.3.8 0 1.1l-4.8 4.8c-.1.2-.3.3-.5.3z",
    fill: "#324d5b"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendance);
export default __webpack_public_path__ + "static/media/attendance.bf9b94dfbfa5376ae7968a1d40d633c4.svg";
export { ForwardRef as ReactComponent };